export const ACADEMY_PATH = "/academy";

export const CONTRIBUTE_PATH = "/contribute";

export const SOLUTIONS_PATH = "/solutions";

export const SOLUTION_SBTI_PATH = `${SOLUTIONS_PATH}/sbti`;

export const SOLUTION_EMPCO_PATH = `${SOLUTIONS_PATH}/empco`;

export const SOLUTION_SCOPE3_PATH = `${SOLUTIONS_PATH}/scope-3`;
